import { useAtom } from '@reatom/npm-react'
import { useTimeout } from 'react-use'
import styled from 'styled-components'

import { Trend } from '@root/entities/trend'
import { DomUtil } from '@root/shared'
import { Fade } from '@root/shared/ui-kit'

import { CHART_HEIGHT } from '../trade-position-chart/constants'
import { TradePositionChart } from '../trade-position-chart/trade-position-chart'

import PATTERN from './assets/grid-pattern.inline.webp'
import { TradePositionPair } from './trade-position-pair'
import { TradPositionProfitInfo } from './trade-position-profit-info'

import type { AggregatedPositionModel } from '@root/entities/position'

type TradePositionHeaderProps = {
  position: AggregatedPositionModel
}

export const TradePositionHeader: React.FC<TradePositionHeaderProps> = ({
  position,
}) => {
  const [pnlUsd] = useAtom(position.pnlUsd)
  const [monthChart] = useAtom(position.monthChart)
  const pnlTrend = Trend.of(pnlUsd.pnlPercentage)
  const [isReady] = useTimeout(300)

  return (
    <Root>
      <Highlight />
      <TopContainer>
        <Grid />
        <TradPositionProfitInfo position={position} />
        {isReady() ? (
          <Fade>
            <TradePositionChart entries={monthChart} pnlType={pnlTrend} />
          </Fade>
        ) : (
          <div style={{ height: CHART_HEIGHT }} />
        )}
      </TopContainer>
      <TradePositionPair position={position} />
    </Root>
  )
}

const Root = styled.div`
  position: relative;

  display: grid;
  grid-template-rows: 1fr auto;
`

const TopContainer = styled.div`
  position: relative;

  display: grid;
  padding-block: 0 0;
  grid-template-rows: auto 1fr;
  z-index: 1;
`

const Grid = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;

  background-image: ${DomUtil.cssUrl(PATTERN)};
  background-position-y: 8px;
  background-size: 11px;
  opacity: 0.03;

  mask-image: radial-gradient(
    60% 140px at 50% 100%,
    rgba(0, 0, 0, 1) 40%,
    transparent 100%
  );
`

const Highlight = styled.div`
  position: absolute;
  bottom: 42px;
  left: calc(50% - (285px / 2));

  border-radius: 285px;
  width: 285px;
  height: 47px;
  opacity: 0.15;
  background: var(--pnl-color);
  filter: blur(35px);
`
